<template>
  <div v-if="errorState.show" class="error-popup-overlay" @click="close">
    <div class="error-popup" @click.stop>
      <!-- Welcome Message Background -->
      <div class="welcome-bg">
        <!-- Error Icon -->
        <div class="error-icon">
          <div class="error-circle-outer">
            <div class="error-circle-inner">
              <div class="error-x">
                <div class="error-x-line error-x-line-1"></div>
                <div class="error-x-line error-x-line-2"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Message -->
        <div class="error-message">{{ errorState.message }}</div>

        <!-- Close Button -->
        <button class="error-button" @click="close">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import { errorState } from "../plugins/errorHandler";

export default {
  name: "ErrorPopup",
  setup() {
    return {
      errorState,
    };
  },
  methods: {
    close() {
      errorState.show = false;
    },
  },
};
</script>

<style scoped>
.error-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.error-popup {
  position: relative;
}

.welcome-bg {
  box-sizing: border-box;
  position: relative;
  width: 399px;
  height: 252px;
  background: #1b1d1e;
  border: 1px solid #3a3c3d;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.error-icon {
  position: absolute;
  width: 58px;
  height: 58px;
  top: 40px;
}

.error-circle-outer {
  position: absolute;
  width: 58px;
  height: 58px;
  background: #4d1c1b;
  border-radius: 50%;
}

.error-circle-inner {
  position: absolute;
  width: 41.76px;
  height: 41.76px;
  left: 8.12px;
  top: 8.12px;
  background: #ff4647;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.error-x {
  position: relative;
  width: 20px;
  height: 20px;
}

.error-x-line {
  position: absolute;
  background-color: #ffffff;
  border-radius: 1px;
}

.error-x-line-1 {
  width: 20px;
  height: 3px;
  top: 50%;
  left: 0;
  transform: translateY(-50%) rotate(45deg);
}

.error-x-line-2 {
  width: 20px;
  height: 3px;
  top: 50%;
  left: 0;
  transform: translateY(-50%) rotate(-45deg);
}

.error-message {
  position: absolute;
  width: 300px;
  top: 120px;
  font-family: "Pretendard", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.error-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 17px 156px;
  gap: 10px;
  position: absolute;
  width: 360px;
  height: 48px;
  bottom: 20px;
  background: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.error-button:hover {
  opacity: 0.9;
}

.error-button-text {
  width: 64px;
  height: 20px;
  font-family: "Pretendard", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -2px;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}
</style>
